import React, { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './Dropdown.module.scss';
import clsx from "clsx";
import { emptyFn } from "presentation/common/helpers/utils";
import { useDetectOutsideClick } from "presentation/common/hooks/useDetectOutsideClick";

export const Dropdown = (props) => {
  const { align, children, items, onSelectItem, disabled } = props;
  const dropdownRef = useRef(null);
  const [isActive, setIsActive] = useDetectOutsideClick(dropdownRef, false);
  const onClick = () => {
    setIsActive(active => !active)
  };

  const selectItem = useCallback((item, index) => {
    onSelectItem(item, index);
    setIsActive(false);
  }, [setIsActive, onSelectItem]);

  return (
    <div>
      <div className={styles.menuContainer}>
        <button onClick={onClick} className={clsx(styles.menuTrigger, { [styles.disabled]: disabled })}>
          {children}
        </button>
        <nav
          ref={dropdownRef}
          className={clsx(styles.menu, { [styles.active]: isActive }, align === 'left' ? styles.left : styles.right)}>
          {
            !disabled &&
            <ul>
              {
                items.map((item, index) => {
                  return (
                    <li key={item.id} className={clsx({ [styles.disabled]: item.disabled })}>
                      <a onClick={() => !item.disabled && selectItem(item, index)}>{item.label}</a>
                    </li>
                  );
                })
              }
            </ul>
          }
        </nav>
      </div>
    </div>
  );
};

Dropdown.propTypes = {
  children: PropTypes.node,
  align: PropTypes.oneOf(['left', 'right']),
  items: PropTypes.array,
  onSelectItem: PropTypes.func,
  disabled: PropTypes.bool
}

Dropdown.defaultProps = {
  align: 'right',
  items: [],
  onSelectItem: emptyFn,
  disabled: false
}

export default React.memo(Dropdown);
